import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

import { TipsStatementSection } from '../model';

import { TipsStatementEntryRow } from './tips-statement-entry-row';

type TipsStatementSectionBlockProps = {
  section: TipsStatementSection;
};

const Section = styled.section.attrs({
  'data-ui': 'tips-statement-section-block',
})`
  display: grid;
  gap: ${({ theme }) => theme.scale.px(10)};
`;

const SectionTitle = styled.h2`
  margin: 0;
  font-size: ${({ theme }) => theme.scale.px(16)};
  font-weight: 400;
  line-height: ${({ theme }) => theme.scale.px(19)};
`;

const EntryList = styled.div`
  display: grid;
`;

export function TipsStatementSectionBlock({
  section,
}: TipsStatementSectionBlockProps) {
  const { t } = useTranslation();

  return (
    <Section>
      <SectionTitle>
        {section.titleKey ? t(section.titleKey) : section.title}
      </SectionTitle>
      <EntryList>
        {section.entries.map(entry => (
          <TipsStatementEntryRow key={entry.id} entry={entry} />
        ))}
      </EntryList>
    </Section>
  );
}
